/**
 * Converts a JavaScript object to a URI encoded query string.
 * @param {any} obj The parameters for the query string.
 */
export function createQueryString(obj, queryStringExists) {
    if (!obj || obj.length === 0) {
        return null;
    }
    var params = [];
    for (var property in obj) {
        if (!obj.hasOwnProperty(property)) {
            continue;
        }
        if (obj[property] instanceof Array) {
            for (var index in obj[property]) {
                if (obj[property].hasOwnProperty(index)) {
                    params.push(encodeURIComponent(property) + '=' + (obj[property][index] !== null && typeof obj[property][index] !== 'undefined' ? encodeURIComponent(obj[property][index]) : ''));
                }
            }
        }
        else {
            params.push(encodeURIComponent(property) + '=' + (obj[property] !== null && typeof obj[property] !== 'undefined' ? encodeURIComponent(obj[property]) : ''));
        }
    }
    return (queryStringExists ? '&' : '?') + params.join('&');
}
/**
 * Generates a random GUID string.
 */
export function generateGuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}
/**
 * Parses out the origin from the provided URL.
 * @param {string} url The URL to parse.
 */
export function parseOriginFromUrl(url) {
    var matches = url.match(/^(([^:\/?#]+:)?(?:\/\/((?:([^\/?#:]*):([^\/?#:]*)@)?([^\/?#:]*)(?::([^\/?#:]*))?)))?([^?#]*)(\?[^#]*)?(#.*)?$/);
    return matches ? matches[1] : url;
}
/**
 * Creates map from an enumeration.
 * @param {Map} mapRef The map to populate.
 * @param {enum} enumRef The enum to map from.
 */
export function mapFromEnum(mapRef, enumRef) {
    for (var key in enumRef) {
        if (enumRef.hasOwnProperty(key)) {
            var value = enumRef[key];
            mapRef.set(value, value);
        }
    }
}
/**
 * Creates a deep clone of the provided object.
 * @param {object} obj The object to clone.
 */
export function clone(obj) {
    if (typeof obj !== 'object') {
        return obj;
    }
    return JSON.parse(JSON.stringify(obj));
}
